export default "__VITE_ASSET__THsOlpy7__"